import React, { useState, useEffect } from 'react';
import '../styles/HelpTip.css';

// 도움말 컴포넌트
const HelpTip = ({ tipId, title, content }) => {
  const [isVisible, setIsVisible] = useState(false);
  
  // 도움말 토글
  const toggleHelp = (e) => {
    e.stopPropagation();
    setIsVisible(!isVisible);
  };
  
  // 외부 클릭시 닫기
  useEffect(() => {
    const closeHelp = () => setIsVisible(false);
    if (isVisible) {
      document.addEventListener('click', closeHelp);
    }
    return () => {
      document.removeEventListener('click', closeHelp);
    };
  }, [isVisible]);
  
  return (
    <div className="help-tip-container">
      <span 
        className="help-icon" 
        onClick={toggleHelp}
      >
        ?
      </span>
      
      {isVisible && (
        <div className="help-tip-box" onClick={(e) => e.stopPropagation()}>
          <h3>{title}</h3>
          <p>{content}</p>
          <div className="help-tip-arrow"></div>
        </div>
      )}
    </div>
  );
};

export default HelpTip; 